export default __webpack_public_path__ + "static/media/IBMPlexSans-TextItalic.24da1d48.woff";